import {Component, computed, effect, inject, signal} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {ActivatedRoute, Router} from '@angular/router';
import {
  FetchProductsStore,
  ProductsCountService,
} from '@em/data-feed/data-access-products';
import {EmEmptyStateComponent, EmThreeDotsLoadingModule} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'em-products-missing-page',
  imports: [EmEmptyStateComponent, TranslateModule, EmThreeDotsLoadingModule],
  templateUrl: './products-missing-page.component.html',
  styleUrls: ['./products-missing-page.component.scss'],
})
export class EmProductsMissingPageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly _fetchProductsStore = inject(FetchProductsStore);
  private readonly _productsCountService = inject(ProductsCountService);

  queryParams = toSignal(this.route.queryParamMap);
  returnUrl = computed(
    () => this.queryParams()?.get('redirect_url') || '/overview',
  );
  lastFetchSuccess = toSignal(this._fetchProductsStore.lastSuccess$);
  lastFetchFail = toSignal(this._fetchProductsStore.lastFail$);
  fetchInProgress = toSignal(this._fetchProductsStore.inProgress$);
  productsCount = toSignal(this._productsCountService.productsCount$);

  constructor() {
    effect(() => {
      // after loading once there are products, make a redirect
      if (this.productsCount()) {
        this.navigateToRedirectUrl();
      }
    });
  }

  startProductImporting(): void {
    this.router.navigate(['/pipelines/add'], {
      queryParams: {redirect_url: this.returnUrl()},
    });
  }

  toDataSources(): void {
    this.router.navigate(['/pipelines/list'], {
      queryParams: {redirect_url: this.returnUrl()},
    });
  }

  navigateToRedirectUrl() {
    const url = this.returnUrl();
    this.router.navigateByUrl(url);
  }

  contactSupport(): void {
    window.location.href = 'mailto:customer-service@repricing.com';
  }

  reImport() {
    this._fetchProductsStore.fetchProducts();
  }
}
